/* eslint-disable react-hooks/exhaustive-deps, react-hooks/rules-of-hooks */
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { skills } from '../../mock';
/* eslint-enable react-hooks/exhaustive-deps, react-hooks/rules-of-hooks */

const BoldSkillsSection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  
  const coreSkills = skills.slice(0, 6);
  const alsoStrongSkills = skills.slice(6);

  return (
    <section id="skills" className="py-32 px-6 relative overflow-hidden">
      <div className="section-watermark" style={{ top: '5%', left: '-5%' }}>05</div>
      
      <div className="max-w-6xl mx-auto" ref={ref}>
        <motion.h2
          className="text-center mb-24 gradient-text"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          style={{ fontFamily: 'Clash Display, Inter, sans-serif' }}
        >
          What I bring
        </motion.h2>
        
        {/* Core Skills - Static Wrapping Pills */}
        <div className="mb-16">
          <motion.h3
            className="text-2xl font-bold text-[#EDE9FE] mb-8 text-center"
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ delay: 0.3 }}
          >
            Core
          </motion.h3>
          
          <motion.div
            className="flex flex-wrap gap-6 justify-center"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={{
              visible: {
                transition: {
                  staggerChildren: 0.1
                }
              }
            }}
          >
            {coreSkills.map((skill, index) => (
              <motion.div
                key={skill.name}
                className="px-8 py-4 bg-gradient-to-r from-[#7C3AED] to-[#C026D3] text-white rounded-full border-2 border-[#FF5C39]/30 font-bold text-xl shadow-lg"
                // eslint-disable-next-line react-hooks/exhaustive-deps
                variants={{
                  hidden: { 
                    opacity: 0, 
                    scale: 0,
                    rotate: Math.random() * 360
                  },
                  // eslint-disable-next-line react-hooks/exhaustive-deps
                  visible: { 
                    opacity: 1, 
                    scale: 1,
                    rotate: 0,
                    transition: {
                      type: "spring",
                      stiffness: 260,
                      damping: 20
                    }
                  }
                }}
                whileHover={{ scale: 1.15, rotate: 5 }}
                style={{ fontFamily: 'Clash Display, Inter, sans-serif' }}
              >
                {skill.name}
              </motion.div>
            ))}
          </motion.div>
        </div>
        
        {/* Also Strong - Scatter Grid */}
        <div>
          <motion.h3
            className="text-xl font-semibold text-[#9D97B5] mb-8 text-center"
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ delay: 0.5 }}
          >
            Also strong
          </motion.h3>
          
          <motion.div
            className="flex flex-wrap gap-4 justify-center"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={{
              visible: {
                transition: {
                  staggerChildren: 0.08
                }
              }
            }}
          >
            {alsoStrongSkills.map((skill, index) => (
              <motion.span
                key={skill.name}
                className="relative px-5 py-2.5 text-[#9D97B5] rounded-full font-medium text-base overflow-hidden group transition-all duration-300"
                style={{
                  background: 'linear-gradient(#1A1430 0 0) padding-box, linear-gradient(135deg, #7C3AED80, #C026D380) border-box',
                  border: '2px solid transparent'
                }}
                // eslint-disable-next-line react-hooks/exhaustive-deps
                variants={{
                  hidden: { 
                    opacity: 0, 
                    scale: 0,
                    rotate: Math.random() * 360
                  },
                  // eslint-disable-next-line react-hooks/exhaustive-deps
                  visible: { 
                    opacity: 1, 
                    scale: 1,
                    rotate: 0,
                    transition: {
                      type: "spring",
                      stiffness: 260,
                      damping: 20
                    }
                  }
                }}
                whileHover={{ scale: 1.12, rotate: Math.random() * 10 - 5 }}
              >
                {/* Gradient glow fill on hover */}
                <span className="absolute inset-0 rounded-full bg-gradient-to-r from-[#7C3AED]/0 via-[#C026D3]/30 to-[#7C3AED]/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
                
                <span className="relative z-10 group-hover:text-[#EDE9FE] transition-colors duration-300">{skill.name}</span>
              </motion.span>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BoldSkillsSection;